import React, { useState } from 'react';
import { IconButton, Popover, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/pro-light-svg-icons';
import MssTooltip from '../../common/MssTooltip';

export const ShortcutButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <MssTooltip id="studyDeck__tooltip_shortcut" title="Keyboard shortcuts">
        <IconButton
          id="studyDeck__iconButton_shortcut"
          className="toolbarIconButton"
          size="small"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-label="Keyboard shortcuts"
        >
          <FontAwesomeIcon icon={faKeyboard} />
        </IconButton>
      </MssTooltip>
      <Popover
        id="studyDeck__popover_shortcut"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        className="mss__studyPopover"
      >
        <Typography id="studyDeck__text_shortcutLine1" className="popoverText">
          Press ← to study again or → if you know the answer
        </Typography>
        <Typography id="studyDeck__text_shortcutLine2" className="popoverText">
          Press <strong>SPACE</strong> or click on the card to flip
        </Typography>
      </Popover>
    </>
  );
};
